import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'
import {cancelDeferHandlerAfterDestroy} from '@rambler-id/react'
import createReducer from './reducers'

export default function configureStore(initialState) {
  const middleware = [thunk, cancelDeferHandlerAfterDestroy]

  let createStoreWithMiddlewares

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line
    const createLogger = require('redux-logger').createLogger

    createStoreWithMiddlewares = compose(
      applyMiddleware(...middleware, createLogger()),
      window.devToolsExtension ? window.devToolsExtension() : (f) => f
    )(createStore)
  } else {
    createStoreWithMiddlewares = applyMiddleware(...middleware)(createStore)
  }

  const store = createStoreWithMiddlewares(createReducer(), initialState)

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers))
    })
  }

  return store
}
